export const ROUTER = Object.freeze ({
    PAGE_UPGRADE: 'upgrade', //dialog xac nhan block account
    PAGE_EXTEND: 'extend', // dialog xac nhan xoa account 
    PAGE_PURCHASE: 'purchase', // dialog xac nhan reject account
    PAGE_CREATE_LICENSE_DETAIL: 'create-license-detail', // trang tao license detail cho chi nhanh
    PAGE_NEW_BRANCH: 'new-branch', // trang approve/edit request new branch
})